// import "../static/font.css"
// import "../static/style.css"

import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store/store"
// import axios from 'axios'

// import "../static/bootstrap.min.css"
// import animated from "animate.css"

// import 'babel-polyfill'
// require('es6-promise').polyfill()

// import {
//     Popover,
//     CollapseTransition
// } from 'element-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// 按需引入vant组件
import {
    Toast,
    Button,
    Pagination,
    Empty,
    Popup,
    Loading
} from 'vant'
import 'vant/lib/index.css'
import "../static/font.css"
import "../static/style.css"

// muse-ui
import 'muse-ui/lib/styles/base.less'
import { Picker } from 'muse-ui';
import 'muse-ui/lib/styles/theme.less';

// import "../static/common.min.js"

import "../node_modules/swiper/dist/css/swiper.min.css";
// import 'element-ui/lib/theme-chalk/index.css'
import "./untils/validate"

//懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: require('./images/loading.svg'),
    loading: require('./images/loading.svg'),
    attempt: 1
})

// 基于photoswipe的vue图片预览插件
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
// 全局注册photoswipe组件
Vue.use(preview)

// Vue.use(animated)
// Vue.use(Popover)
// Vue.component(CollapseTransition.name, CollapseTransition)

// 使用vant组件
Vue.use(Toast)
    .use(Button)
    .use(Pagination)
    .use(Empty)
    .use(Popup)
    .use(Loading)


// 使用muse-ui组件
Vue.use(Picker)

// Vue.config.productionTip = false;

// store.state.baseURL = axios.defaults.baseURL;

Vue.filter('NumFormat', function(value) {
    if (!value) return '0';
    var intPart = Number(value).toFixed(0); //获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
    return intPartFormat;
})

Vue.filter('NumFormatIcon', function(value) {
    if (!value) return '0';
    var intPart = Number(value).toFixed(0); //获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
    return '$' + intPartFormat;
})

Vue.filter('NumFormatPrice', function(value) {
    if (!value) return '0'
    let intPart = Number(value).toFixed(2) //获取整数部分
    let intPartFormat = intPart
    let strTemp = intPart.toString()
    let strs = intPart.split('.')
    let str = strs[1]
    if (str == '00') {
        intPartFormat = strs[0]
    } else if (str.split('')[1] == '0') {
        intPartFormat = strTemp.substring(0, strTemp.length - 1)
    }
    intPartFormat = intPartFormat.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') //将整数部分逢三一断
    return intPartFormat
})

Vue.directive('preventReClick', {
    inserted(el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 2000)
            }
        })
    }
})

import './untils/scroll-to'

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js